/* eslint-disable */
import { useEffect, useState, useContext } from "react";
import { useMutation } from "@apollo/client";
import { useNavigate } from "react-router";
import { Box, Button, Container, FormControl, FormControlLabel, Grid, Radio, RadioGroup, styled, TextField, Typography } from "@mui/material";
import { LOGOUT, UpdateUser } from "../../gql/mutations/auth";
import useQuery from "../../hooks/allQuery";
import { usePopup } from "../../context/commonPop";
import ImportProject from "../ProjectList/ImportProject";
import StartFreePlan from "../ProjectList/StartFreePlan";
import { useSearchParams } from "react-router-dom";
import { GetScrapyData } from "../../hooks/scrapyData";
import GreenLogo from "../Logo/GreenLogo";
import { LocalStorageKey } from "../../common/constant";
import { useDispatch } from "react-redux";
import { logoutUser, resetCustomizer } from "../../redux/action";
import logoutBtn from "../../Images/md-log-out.svg";
import { AuthContext } from "../../AuthContext";
import LogoutPopUp from "../Modal/LogoutPopupFirst";
const SectionWrapper = styled("section")(({ theme }) => ({
  minHeight: "100vh",
  backgroundColor: "#EFF3FB",
  paddingTop: "30px",
  paddingBottom: "30px",

  "& .LogoWrapper": {
    textAlign: "center",
    "& img": { width: "105px", height: "auto" },
  },
  "& .logOutBtn": {
    textTransform: "none",
    backgroundColor: "transparent",
    color: "#E83D62",
    borderRadius: "5px",
    boxShadow: "none",
    border: "1.5px solid #E83D62",
    fontWeight: 700,
    fontSize: "14px",
    lineHeight: "17.64px",
    minWidth: "165px",
    width: "165px",
    padding: "11px 0",
    marginLeft: "auto",
    transition: "0.3s all",
    "@media screen and (max-width:600px)": {
      width: "100px",
      minWidth: "100px  ",
    },
    "& img": {
      marginRight: "8px",
    },
    "&:hover": {
      backgroundColor: "transparent",
      boxShadow: "none",
      color: "#E83D62",
      transform: "scale(1.05)",
      "& a": { color: "#ff642d" },
      "& svg": { transform: "rotateZ(720deg)" },
    },
    "&:focus": { outline: "none" },
  },
  "& .AccountDetailsWrapper": {
    backgroundColor: "#ffffff",
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: "6px",
    padding: "28px 20px 20px",
    "& .MainHeading": { color: "#2A3547", textAlign: "center", lineHeight: 1, fontSize: "24px", fontWeight: 700, marginBottom: "10px" },
    "& .SubHeading": {
      color: "#757575",
      textAlign: "center",
      lineHeight: 1,
      fontSize: "14px",
      fontWeight: 500,
    },
    "& .ChooseListWrapper": {
      marginTop: "25px",
      "& .MuiFormControl-root": {
        width: "100%",
        "& .MuiFormGroup-root": {
          "& label": {
            marginLeft: "0",
            marginBottom: "10px",
            marginRight: "0",
            width: "100%",
            justifyContent: "space-between",
            border: `1px solid ${theme.palette.divider}`,
            borderRadius: "6px",
            padding: "14px 14px 14px 14px",
            "& span.MuiRadio-root": {
              padding: "0px",
            },
            "& span.MuiFormControlLabel-label": {
              color: "#BEBEBE",
              textAlign: "center",
              lineHeight: 1,
              fontSize: "16px",
              fontWeight: 600,
            },
            "&.active": {
              borderColor: "#45C0CB",
              backgroundColor: "#45c0cb0f",
              "& span.MuiFormControlLabel-label": {
                color: "#2A3547",
              },
              "& span.MuiRadio-root": {
                "&.Mui-checked": { color: "#45C0CB" },
              },
            },
          },
        },
        "& .MuiFormControl-root": {
          marginTop: "0",
          marginBottom: "0",
          "& .MuiInputBase-root": {
            "& fieldset": { display: "none" },
            "& input": { border: `1px solid #45C0CB`, borderRadius: "6px", padding: "14px 14px 14px 14px" },
          },
        },
      },
    },
    "& .BtnWrapper": {
      marginTop: "15px",
      "& button": {
        textTransform: "none",
        backgroundColor: "#45C0CB",
        color: "#ffffff",
        borderRadius: "5px",
        boxShadow: "none",
        padding: "12px 22px 10px",
        width: "100%",
        "&:focus": {
          outline: "0",
        },
      },
    },
  },
}));
function SignUpUserProjectResister() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [logout, setLogout] = useState(false);
  const { scrapyData } = GetScrapyData();
  const [logOutCall] = useMutation(LOGOUT);
  const { removeAuth } = useContext(AuthContext);

  useEffect(() => {
    if (scrapyData && Array.isArray(scrapyData)) {
      const varifiedProjects = scrapyData.filter(project => project?.isVerified === false);
      if (varifiedProjects.length > 0) {
        const { id } = varifiedProjects[0];
        navigate(`/project-config/${id}`);
      }
    }
  }, [scrapyData]);

  const handleLogout = () => {
    setLogout(true);
  };
  const handleLogoutConfirm = async () => {
    logOutCall({
      variables: {
        token: sessionStorage.getItem(LocalStorageKey.REFRESH_TOKEN) || localStorage.getItem(LocalStorageKey.REFRESH_TOKEN),
      },
      onCompleted: () => {
        removeAuth();
        window.dispatchEvent(new Event("storage"));
        dispatch(logoutUser(true));
        dispatch(resetCustomizer());
        setLogout(false);
        navigate("/");
      },
      onError: error => {
        console.log("error", error);
      },
    });
  };

  return (
    <SectionWrapper>
      <LogoutPopUp logout={logout} setLogout={setLogout} onLogout={handleLogoutConfirm} />
      <Container>
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2} mt={0} justifyContent="center">
            <Grid item xs={12} md={6}>
              <Box className="LogoWrapper">
                <GreenLogo />
              </Box>
            </Grid>
            <Box sx={{ width: "100%", textAlign: { xs: "center", sm: "end" } }}>
              <Button variant="outlined" color="primary" onClick={handleLogout} className="logOutBtn">
                <Typography component="img" src={logoutBtn} alt="" />
                Logout
              </Button>
            </Box>
          </Grid>
          <Grid container spacing={2} mt={0} justifyContent="center">
            <Grid item xs={12} md={12}>
              <ImportProject />
            </Grid>
            <Grid item xs={12} md={12}>
              <StartFreePlan />
            </Grid>
          </Grid>
        </Box>
      </Container>
    </SectionWrapper>
  );
}

export default SignUpUserProjectResister;
